<template>
  <div class="news-page">
    <!-- Banner -->
    <div class="page_vision_banner">
      <img src="@/assets/images/page_banner_news.jpg">
      <h3>
        <span>新闻中心</span>
        <font></font>
        <strong>华合半导体将为您分享更多芯片和半导体业界的新进展</strong>
        <!-- <span></span>
        <p>
          <b>
            <f>新闻中心</f>
            <g>\ NEWS</g>
          </b>
          <c></c>
          <e>华合半导体将为您分享更多芯片和半导体业界的新进展</e>
        </p> -->
      </h3>
    </div>

    <!-- 面包屑 -->
    <div class="page_dg">
      <div>
        <left>
          <router-link to="/">主页</router-link> &gt;
          <router-link to="/news">新闻中心</router-link>
        </left>
      </div>
    </div>

    <!-- 新闻列表 -->
    <div class="page_news">
      <div class="page_news_list">
        <left>
          <dl>
            <a v-for="(news, index) in newsList" :key="index" @click="goToDetail(news)">
              <img :src="news.newImg">
              <h2>
                <b>{{ news.newNameCn }}</b>
                <c>{{ news.newSynopsisCn }}</c>
                <span class="read-more">阅读全文 > </span>
                <e>{{ news.createTime }}</e>
              </h2>
            </a>
            <div class="feiye" v-if="pages > 1">
              <a @click="goToPage(1)" :class="{ disabled: currentPage === 1 }">首页</a>
              <a @click="goToPage(currentPage - 1)" :class="{ disabled: currentPage === 1 }">上一页</a>
              <span v-for="page in pages" :key="page" @click="goToPage(page)" :class="{ active: currentPage === page }">{{ page }}</span>
              <a @click="goToPage(currentPage + 1)" :class="{ disabled: currentPage === pages }">下一页</a>
              <a @click="goToPage(pages)" :class="{ disabled: currentPage === pages }">末页</a>
            </div>
          </dl>
        </left>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  metaInfo: {
    title: '新闻中心_半导体行业动态_南京华合半导体科技有限公司',
    meta: [
      { name: 'description', content: '南京华合半导体新闻中心，分享化合物半导体行业最新动态、公司新闻、技术资讯、展会信息等。了解GaAs/GaN功放芯片、器件模型、PDK开发等领域前沿资讯。' },
      { name: 'keywords', content: '半导体新闻,化合物半导体,GaAs芯片,GaN芯片,行业动态,南京华合半导体,技术资讯,展会信息' },
      { name: 'robots', content: 'index,follow' },
      { property: 'og:title', content: '新闻中心 - 南京华合半导体科技有限公司' },
      { property: 'og:url', content: 'https://huaheic.com/news' }
    ],
    link: [
      { rel: 'canonical', href: 'https://huaheic.com/news' }
    ]
  },
  data() {
    return {
      newsList: [],
      currentPage: 1,
      pageSize: 5,
      pages: 0,
      total: 0
    }
  },
  created() {
    this.getNewsList()
  },
  methods: {
    getNewsList() {
      this.$request.get('/wx/news/getListByClassIfy', {
        "newType": "1",
        "currentPage": this.currentPage,
        "pageSize": this.pageSize
      }).then(response => {
        this.newsList = response.data.records
        this.pages = response.data.pages
        this.total = response.data.total
      })
    },
    goToPage(page) {
      if (page < 1 || page > this.pages) return
      this.currentPage = page
      this.getNewsList()
    },
    goToDetail(news) {
      if(news.newNameEn){
        window.open(news.newNameEn)
        return 
      }
      this.$router.push({
        path: '/news/detail',
        query: { id: news.id }
      })
    }
  }
}
</script>

<style scoped>
/* 确保阅读全文显示 */
.read-more {
 color: #0aacf2;font-size: 15px;;
}

/* 分页样式 - 未选中红色，选中蓝色 */
.feiye span {
  background: #DCDCDC !important;
  color: #fff !important;
}

.feiye span.active {
  background: #06509C !important;
  color: #fff !important;
}

.feiye a.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media screen and (max-width: 740px) {
    .read-more {
        /* display: block; */
        font-size: 12px;
        color: #0aacf2;
        margin-top: 0.5em;
      
    }
    .page_vision_banner {
        height: 150px;
        padding-top: 54px;
    }
    
    .page_vision_banner h3 strong {
        display: block;
        font-size: 12px;
        color: #fff;
        margin-top: 0.5em;
        text-align: center;
    }
}
</style>
